import { format, parse, parseISO } from "date-fns";

export function convertDateToDDMMYYYY(inputDate: string): string {
  const [year, month, day] = inputDate.split("-");
  return `${day}/${month}/${year}`;
}

export function createCurrentDateString(): string {
  const current = new Date();
  return `${current.getFullYear()}-${current.getMonth() + 1}-${current.getDate()}T00:00:00+01:00`;
}

export function formatDate(inputDate: Date | string): string {
  const date = new Date(inputDate);
  return new Intl.DateTimeFormat("en-US", {
    year: "numeric",
    month: "long",
    day: "numeric",
  }).format(date);
}

export function createDateStringFromInput(input: Date | string): string {
  const date = typeof input === "string" ? parseISO(input) : input;
  return format(date, "yyyy-MM-dd") + "T00:00:00+01:00";
}

export function formatDateTime(date: string, time: string): string {
  if (!date || !time) return "";

  const combinedDateTime = parse(
    `${date} ${time}`,
    "yyyy-MM-dd HH:mm",
    new Date(),
  );

  return format(combinedDateTime, "yyyy-MM-dd'T'HH:mm:ss'Z'");
}

export function formatLocalDateTime(date: Date): string {
  const pad = (n: number) => String(n).padStart(2, "0");

  const year = date.getFullYear();
  const month = pad(date.getMonth() + 1);
  const day = pad(date.getDate());
  const hours = pad(date.getHours());
  const minutes = pad(date.getMinutes());
  const seconds = pad(date.getSeconds());

  return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}`;
}
